import { useContext } from 'react';
import ErrorContext from './ErrorContextUtils';

/**
 * Custom hook to consume the error context.
 * @returns {{ error: string|null, isErrorVisible: boolean, showError: function, hideError: function }}
 */
export const useErrorContext = () => {
  const context = useContext(ErrorContext);
  if (!context) {
    throw new Error('useErrorContext must be used within an ErrorProvider');
  }
  return context;
};
